import { render, staticRenderFns } from "./PlayerQuoteWidget.vue?vue&type=template&id=ae677f1c&scoped=true"
import script from "./PlayerQuoteWidget.vue?vue&type=script&lang=js"
export * from "./PlayerQuoteWidget.vue?vue&type=script&lang=js"
import style0 from "./PlayerQuoteWidget.vue?vue&type=style&index=0&id=ae677f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae677f1c",
  null
  
)

export default component.exports